import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Layout } from "antd";
import PurchaseMembershipPaymentStatus from "../components/PurchaseMembershipPaymentStatus";

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_KEY}`);

const PurchaseMembershipPaymentStatusPage = () => {
  return (
    <Layout>
      <Layout.Content>
        <Elements stripe={stripePromise}>
          <PurchaseMembershipPaymentStatus />
        </Elements>
      </Layout.Content>
    </Layout>
  );
};

export default PurchaseMembershipPaymentStatusPage;
